/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select';
import SalesByProductChart from './SalesByProductChart';
import { sortByOptionsForPOS } from '../../helper'
import { setCurrencyFormat } from '../../../../utils/helpers';

const SalesByProductShow = ({ dir, data, viewReportButton, title, optionShow, 
    companyBasedOn, categorisedBasedOn }) => {
    const thisMonthData = {};
    const currentDataByCompany = {};
    const categorisedBasedOnRef = useRef({ categorisedBasedOn });

    const [sortBySelected, setSortBySelected] = useState(sortByOptionsForPOS[1])

    let selectedCatName = '';
    if (categorisedBasedOn === 'productCategory'){
        selectedCatName = 'Category';
    }
    else if (categorisedBasedOn === 'productCollection'){
        selectedCatName = 'Collection';
    }
    else if (categorisedBasedOn === 'productSubCategory'){
        selectedCatName = 'Sub Category';
    }
    else if (categorisedBasedOn === 'sku'){
        selectedCatName = 'SKU';
    }

    data.forEach((item) => {
        if (item && currentDataByCompany[item?.[companyBasedOn]]) {
            currentDataByCompany[item?.[companyBasedOn]]?.push(item)
        } else if (item) {
          if (!item?.[companyBasedOn] || item?.[companyBasedOn] === 'null') {
            currentDataByCompany?.['N/A']?.push(item)
          } else {
            currentDataByCompany[item?.[companyBasedOn]] = [item]
          }
        }
      });
  const currentCompanyData = Object.keys(currentDataByCompany);
  const options = [];
  let dataToPlot = [];

  const reduceCallbackForCategory = (acc, day) => {
    if (acc[day?.[categorisedBasedOn]]) {
      acc?.[day?.[categorisedBasedOn]]?.push(day)
    } else {
      acc[day?.[categorisedBasedOn]] = [day]
    }    
    return acc
  }

  const reduceCallbackForWeekly = (acc, day) => {
    const MonthWeek = `${day.monthStr}-wk${day?.week}-${day?.year}`;
    if (acc[MonthWeek]) {
      acc?.[MonthWeek]?.push(day)
    } else {
      acc[MonthWeek] = [day]
    }    
    return acc
  }

  const reduceCallbackForMonthly = (acc, day) => {
    const monthData = `${day.monthStr}-${day?.year}`;
    if (acc[monthData]) {
      acc?.[monthData]?.push(day)
    } else {
      acc[monthData] = [day]
    }    
    return acc
  }

  const reduceCallbackForYearly = (acc, day) => {
    const yearData = `${day?.year}`;
    if (acc[yearData]) {
      acc?.[yearData]?.push(day)
    } else {
      acc[yearData] = [day]
    }    
    return acc
  }

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF'.split('');
    let fillColor = '#';
    for (let i = 0; i < 6; i += 1) {
        fillColor += letters[Math.floor(Math.random() * 16)];
    }
    return fillColor;
}

  for (let i = 0; i < currentCompanyData.length; i += 1) {
    const cat = currentCompanyData[i];
    const currentMonth = currentDataByCompany?.[cat] ?? [];
    let currentYearMonthMax = 0;

    currentMonth?.forEach((item) => {
      currentYearMonthMax += Number(item.amount)
    }
    );

    const getDataByType = () => {

    }
    
    const finalDatayearwise = [];   
    const categoryWiseData = currentMonth?.reduce(reduceCallbackForCategory, {})

    const currentCatData = Object.keys(categoryWiseData);
    let finalDataForPlot = [];

     for (let j = 0; j < currentCatData.length; j += 1) {
         const curCat = currentCatData[j];
         const currentCategory = categoryWiseData?.[curCat] ?? [];       
         
         let currentYearMonthDayWise = {}
         if (optionShow?.value === 'weekly'){
          currentYearMonthDayWise = currentCategory?.reduce(reduceCallbackForWeekly, {})
         }
         else if (optionShow?.value === 'monthly'){
          currentYearMonthDayWise = currentCategory?.reduce(reduceCallbackForMonthly, {})
         }
         else {
          currentYearMonthDayWise = currentCategory?.reduce(reduceCallbackForYearly, {})
         }
         
         const innerData = []
         const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
         let amount = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
             Number(item.amount)).toFixed(2)), 0);
         amount = Math.abs(amount); 
         innerData.push({ day: monthyear,
             Amount: amount})
         acc[monthyear] = {
             day: monthyear,
             Amount: amount        
         };
         return acc
         }, {})
         finalDataForPlot.push({
             name: curCat,
             data: innerData,
             color: getRandomColor()
         })
     }   
     finalDataForPlot = finalDataForPlot?.sort((a, b) =>
     a?.name?.toLowerCase() > b?.name?.toLowerCase() ? 1 : -1)
     

    options.push({
      value: cat, label: cat
    })
    
    dataToPlot.push({
      title: cat,
      finalDataForPlot,
      currentYearMonthMax: currentYearMonthMax > 0 ? currentYearMonthMax : 0
    })

  }
  

  const sortBy = sortBySelected?.value;
    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }
    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }} >
                <h5 className="bold-text col-md-5">{title}</h5>  
                <h5 className="bold-text col-md-2"
                 style={{marginTop: 50}}>{selectedCatName} in store</h5>              
                <div className="form__form-group mb-0 col-md-4" id='dvChartFilter'>
                    <div className="row justify-content-center align-items-center">
                    <div className="col-3 text-right">
                      <span className="form__form-group-label font-weight-bold">Sort By</span>
                      </div>
                        <div className="col-4">
                            <div className="form__form-group-field">
                                <Select
                                    value={sortBySelected}
                                    options={sortByOptionsForPOS}
                                    clearable={false}
                                    placeholder="Sort By"
                                    className="select_filter-110"
                                    onChange={setSortBySelected}
                                    classNamePrefix="react-select"
                                />
                            </div>

                        </div>
                    </div>
                </div>
                
                <div className="col-1" id='dvChartView'>
                    {viewReportButton?.()}
                    </div>
                </div>

                {dataToPlot?.length ? dataToPlot?.map((category, index) => (                   
                <Row key={category.title}>
                    <Col sm={4} md={2}><CardText>{category.title} <br />
                        {setCurrencyFormat(Number(category.currentYearMonthMax).toFixed(2), true)}
                        </CardText></Col>
                    <Col sm={8} md={10}>
                        <SalesByProductChart dir={dir}
                            totalDays={365}
                            dataToShow={category?.finalDataForPlot}
                            height={380}
                            showTitle={false}
                            category={category.title}
                            categorisedBasedOn={categorisedBasedOn}
                            index={index}
                        /> 
                        </Col>
                </Row>
            )) : 'No data to display'}
            </Card>
        </Col>

    )
}

SalesByProductShow.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    optionShow: PropTypes.object.isRequired,
    companyBasedOn: PropTypes.string,
    categorisedBasedOn: PropTypes.string
};

SalesByProductShow.defaultProps = {
    title: 'Sales By Product',
    companyBasedOn: 'companyName',
    categorisedBasedOn: 'productCollection'
}

export default SalesByProductShow;
